import React from "react";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";

import countries from "../../Lib/countries.js";

import Input from "./../../Components/Common/Forms/input/index.js";
import ButtonUnderline from "./../../Components/Common/ButtonUnderline/index.js";
import Select from "./../../Components/Common/Select/index.js";
import Button from "./../../Components/Common/Button/index.js";

import styles from "./styles.module.css";


const PREFIX = "legalAddress";

const getName = (name) => {
    return `${PREFIX}${name}`;
};

const FIELDS = {
    country: getName("Country"),
    city: getName("City"),
    address: getName("Address"),
    postCode: getName("PostCode"),
};

const INITIAL_VALUES = {
    [FIELDS.country]: "",
    [FIELDS.city]: "",
    [FIELDS.address]: "",
    [FIELDS.postCode]: "",
};

/* --- */

const FormClientEditLegalAddress = (props) => {
    const { t } = useTranslation();

    /* --- */

    const validateForm = (values) => {
        const errors = {};

        if (!values[FIELDS.country]) {
            errors[FIELDS.country] = "Country is required";
        }

        if (!values[FIELDS.city]) {
            errors[FIELDS.city] = "City is required";
        }

        if (!values[FIELDS.address]) {
            errors[FIELDS.address] = "Address is required";
        }

        if (!values[FIELDS.postCode]) {
            errors[FIELDS.postCode] = "Postal code is required";
        }

        return errors;
    };

    /* --- */

    const isDisabled = (disabled = false) => {
        return !props.isEditable || disabled;
    };

    /* --- */

    const renderForm = (formMethods) => {
        const {
            handleSubmit,
            values,
            errors,
            handleChange,
            handleBlur,
        } = formMethods;

        const {
            country,
            city,
            address,
            postCode,
        } = FIELDS;

        return (
            <form
                className={styles.form}
                onSubmit={handleSubmit}
            >
                <div className={styles.header}>
                    <ButtonUnderline
                        label={t("legal_address")}
                    />
                </div>
                <Select
                    label={t("country")}
                    options={countries.getCountriesOptions()}
                    selected={values[country]}
                    error={errors[country]}
                    onSelect={(value) => {
                        formMethods.setFieldValue(country, value);
                    }}
                    isDisabled={isDisabled()}
                    isFixedHeight
                />
                <Input
                    name={city}
                    label={t("city")}
                    placeholder="Riga"
                    value={values[city]}
                    error={errors[city]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isDisabled={isDisabled()}
                />
                <div className={styles.addressColumn}>
                    <Input
                        name={address}
                        label={t("address")}
                        placeholder="Dzirnavu iela 3"
                        value={values[address]}
                        error={errors[address]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isDisabled={isDisabled()}

                    />
                    <Input
                        name={postCode}
                        label={t("postCode")}
                        placeholder="LV-0000"
                        value={values[postCode]}
                        error={errors[postCode]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isDisabled={isDisabled()}
                    />
                </div>
                <div className={styles.sameAddressButton}>
                    <Button
                        onClick={props.onSameAsLegal}
                        isDisabled={isDisabled()}
                        isRed
                    >
                        {t("same_as_legal_address")}
                    </Button>
                </div>
            </form>
        );
    };

    return (
        <Formik
            initialValues={props.initialValues}
            innerRef={props.formRef}
            validate={validateForm}
        >
            {renderForm}
        </Formik>
    );
};

FormClientEditLegalAddress.defaultProps = {
    formRef: null,
    initialValues: INITIAL_VALUES,
    onSameAsLegal: () => { },
    onSubmit: () => { },
    isEditable: false,
};

export {
    PREFIX,
    INITIAL_VALUES,
    FIELDS,
};

export default FormClientEditLegalAddress;
